'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC, type PropsWithChildren } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokBrandImageCardType } from '../../storyblok'
import { useStoryblokWebOrAppLink } from '../../useStoryblokLink'

export const StoryblokBrandImageCardContent: FC<
  PropsWithChildren<StoryblokComponentProps<StoryblokBrandImageCardType>>
> = ({ blok, children }) => {
  const { appHref, href } = blok
  const linkProps = useStoryblokWebOrAppLink({ appLink: appHref, link: href })

  if (!linkProps) {
    return null
  }

  return (
    <a
      {...storyblokEditable(blok)}
      {...linkProps}
      // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
      className="block h-[170px] rounded-m border border-dark-primary-strong p-6"
    >
      <div className="relative min-h-full min-w-full">{children}</div>
    </a>
  )
}
